import { createSlice } from "@reduxjs/toolkit";

import {
  companyReqeustDriverCall,
  editRequestService,
  inspectorSetCall,
  inspectorSetDriverCall,
  requestDriverDataCall,
  requestIsApprovedConfirmCall,
  requestIsApprovedDriverConfirmCall,
  requestIsCheckedConfirmCall,
  requestIsCheckedDriverConfirmCall,
  requestRemoveService,
} from "../../utils/services/requestService";

import notify from "devextreme/ui/notify";
import { getDriver } from "./driver";
export const slice = createSlice({
  name: "requestDriver",
  initialState: {
    requestData: null,
    requestConfirmedData: null,
    requestSearchData: null,
    requestInspectionData: null,
    inspectorData: null,
    trailerInspectionData: null,
    filter: { is_approved: 0 },
    filterAdmin: { is_approved: 0, is_requested: 1 },
    filterConfirmed: { is_requested: 1 },
    filterConfirmedAdmin: { is_approved: 1 },
    isLoading: true,
  },

  reducers: {
    setFilter: (state, { payload }) => {
      // console.log(payload);
      state.filter = payload;
    },
    setFilterConfirmed: (state, { payload }) => {
      // console.log(payload);
      state.filterConfirmed = payload;
    },
    setLoading: (state, { payload }) => {
      // console.log(payload);
      state.isLoading = payload;
    },
    setRequestSearchData: (state, { payload }) => {
      // console.log(payload);
      state.requestSearchData = payload;
    },
    setRequestData: (state, { payload }) => {
      // console.log(payload);
      state.requestData = payload;
    },
    setRequestIsCheckedData: (state, { payload }) => {
      let listCopy = [...state.requestData];
      listCopy.filter((item) => {
        if (item.id === payload.id) {
          item.is_checked = payload.is_checked;
        }
      });
    },
    setRequestConfirmedData: (state, { payload }) => {
      // console.log(payload);
      state.requestConfirmedData = payload;
    },
    setInspectorData: (state, { payload }) => {
      // console.log(payload);
      state.inspectorData = payload;
    },
    setRequestApprove: (state, { payload }) => {
      // console.log(payload);
      state.requestData.unshift(payload);
    },
    setRequestApproveConf: (state, { payload }) => {
      // console.log(payload);
      state.requestConfirmedData.unshift(payload);
    },

    setRemoveRequest: (state, { payload }) => {
      // console.log(payload);

      let index = state.requestData.findIndex(({ id }) => id === payload);
      state.requestData.splice(index, 1);
    },
    setCanceledRequest: (state, { payload }) => {
      // console.log(payload);

      let index = state.requestConfirmedData.findIndex(
        ({ id }) => id === payload
      );
      state.requestConfirmedData.splice(index, 1);
    },
  },
});

export const {
  setLoading,
  setRequestSearchData,
  setRequestData,
  setCreateRequest,
  setRemoveRequest,
  setRequestApprove,
  setRequestApproveConf,
  setEditRequest,
  setFilter,
  setFilterConfirmed,
  setRequestIsCheckedData,
  setRequestConfirmedData,
  setInspectorData,
  setCanceledRequest,
} = slice.actions;

export const getRequest = (filter) => async (dispatch, getState) => {
  try {
    const responseData = await requestDriverDataCall(filter);

    if (responseData.status.code === 200) {
      // console.log(responseData.data);

      dispatch(setRequestData(responseData.data));
      dispatch(setLoading(false));

      // dispatch(setRequestInspectionData(responseData.data));
    } else {
      /// console.log(responseData);
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "error"
      );
    }

    //console.log(alert);
  } catch (error) {
    console.log(error);
  }
};
export const inspectorSetFun = (filter) => async (dispatch, getState) => {
  try {
    const responseData = await inspectorSetDriverCall(filter);

    if (responseData.status.code === 200) {
      // console.log(responseData.data);

      dispatch(setInspectorData(responseData.data));
      dispatch(setLoading(false));
      dispatch(getRequest({ is_approved: 0, is_requested: 1 }));
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "success"
      );
      // dispatch(setRequestInspectionData(responseData.data));
    } else {
      /// console.log(responseData);
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "error"
      );
    }

    //console.log(alert);
  } catch (error) {
    console.log(error);
  }
};
export const getRequestConfirmed =
  (filterConfirmed) => async (dispatch, getState) => {
    try {
      const responseData = await requestDriverDataCall(filterConfirmed);

      if (responseData.status.code === 200) {
        // console.log(responseData.data);

        dispatch(setRequestConfirmedData(responseData.data));
        dispatch(setLoading(false));

        // dispatch(setRequestInspectionData(responseData.data));
      } else {
        /// console.log(responseData);
        notify(
          {
            message: responseData.status.message,
            width: 450,
          },
          "error"
        );
      }

      //console.log(alert);
    } catch (error) {
      console.log(error);
    }
  };

export const createRequest = (formData, type) => async (dispatch, getState) => {
  try {
    const responseData = await editRequestService(formData);
    //  console.log(responseData);
    if (responseData.status.code === 200) {
      if (type === 2) {
        dispatch(setEditRequest(responseData.data[0]));
      } else {
        dispatch(setCreateRequest(responseData.data[0]));
      }
      //  dispatch(getRequest());
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "success"
      );
      // dispatch(setRequestInspectionData(responseData.data));
    } else {
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "error"
      );
    }

    //console.log(alert);
  } catch (error) {
    console.log(error);
  }
};
export const removeRequestList = (requestId) => async (dispatch, getState) => {
  try {
    const responseData = await requestRemoveService(requestId);
    if (responseData.status.code === 200) {
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "success"
      );
      dispatch(getDriver({ is_approved: 0, is_requested: 0 }));
      dispatch(getRequestConfirmed({ is_requested: 1 }));
    }
  } catch (error) {
    console.log(error);
  }
};
export const requestIsCheckedConfirm =
  (reqId, note) => async (dispatch, getState) => {
    try {
      // console.log(data);
      const data = {
        id: reqId,
        note: note,
        is_checked: 1,
      };
      const responseData = await requestIsCheckedDriverConfirmCall(data);
      // console.log(responseData);
      if (responseData.status.code === 200) {
        // console.log("ffffffffffffffff");
        // console.log(responseData.data);
        dispatch(setRequestIsCheckedData(responseData.data));
        // dispatch(setRequestInspectionData(responseData.data));
      } else {
        notify(
          {
            message: responseData.status.message,
            width: 450,
          },
          "success"
        );
      }

      //console.log(alert);
    } catch (error) {
      console.log(error);
    }
  };
export const requestIsApprovedConfirm =
  (reqId, note) => async (dispatch, getState) => {
    try {
      // console.log(data);
      const data = {
        id: reqId,

        note: "Батлав",
        is_approved: 1,
      };
      // console.log(data);
      const responseData = await requestIsApprovedDriverConfirmCall(data);
      // console.log(responseData);
      if (responseData.status.code === 200) {
        // console.log("ffffffffffffffff");
        // console.log(responseData.data);

        dispatch(setRemoveRequest(reqId));
        dispatch(setRequestApproveConf(responseData.data));
        // dispatch(setRequestInspectionData(responseData.data));
      } else {
        notify(
          {
            message: responseData.status.message,
            width: 450,
          },
          "error"
        );
      }

      //console.log(alert);
    } catch (error) {
      console.log(error);
    }
  };
export const requestIsApprovedCancel = (data) => async (dispatch, getState) => {
  try {
    // console.log(data);

    // console.log(data);
    const responseData = await requestIsApprovedDriverConfirmCall(data);
    // console.log(responseData);
    if (responseData.status.code === 200) {
      // console.log("ffffffffffffffff");
      // console.log(responseData.data);

      dispatch(setCanceledRequest(data.id));
      dispatch(setRequestApprove(responseData.data));
      // dispatch(setRequestInspectionData(responseData.data));
    } else {
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "error"
      );
    }

    //console.log(alert);
  } catch (error) {
    console.log(error);
  }
};
export const companyReqeustDriverFun = (data) => async (dispatch, getState) => {
  try {
    const responseData = await companyReqeustDriverCall(data);

    if (responseData.status.code === 200) {
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "success"
      );
      dispatch(getDriver({ is_approved: 0, is_requested: 0 }));
      dispatch(getRequestConfirmed({ is_requested: 1 }));
      // dispatch(setRequestInspectionData(responseData.data));
    } else {
      /// console.log(responseData);
      notify(
        {
          message: responseData.status.message,
          width: 450,
        },
        "error"
      );
    }

    //console.log(alert);
  } catch (error) {
    console.log(error);
  }
};

export default slice.reducer;
